const app = "ehr_pc"; //应用名称，用于多套部署cookie隔离

import API from "./apiconfig.js";
import HTTP from "./http.js";
import DateUtil from './dateutils.js';

import MD5 from "./md5.js";

import NoticeApi from "./notice/apiconfig.js";
//---------------------------------
var layui = window.layui;




//by函数接受一个成员名字符串和一个可选的次要比较函数做为参数
//并返回一个可以用来包含该成员的对象数组进行排序的比较函数
//当o[age] 和 p[age] 相等时，次要比较函数被用来决出高下
var by = function (name, minor) {
    return function (o, p) {
        var a, b;
        if (o && p && typeof o === 'object' && typeof p === 'object') {
            a = o[name];
            b = p[name];
            if (a === b) {
                return typeof minor === 'function' ? minor(o, p) : 0;
            }
            if (typeof a === typeof b) {
                return a < b ? -1 : 1;
            }
            return typeof a < typeof b ? -1 : 1;
        } else {
            thro("error");
        }
    }
};









import $ from 'jquery'
import jsCookie from 'js-cookie'
//---------------------------------
//let httpArr = [];  //判断到登录无效时，后续请求进等待队列，避免多次弹出未登录

import Constant from './constant.js'

const common = {
    //attribute......

    User: {
        Token: function (val) {
            if (!val) {
                //获取值
                var user = layui.data(app + 'User');
                return user.Token;
            } else {
                if (val == null) {
                    //删除值
                    layui.data(app + 'User', {
                        key: 'Token',
                        remove: true
                    });
                } else {
                    //设置值
                    layui.data(app + 'User', {
                        key: 'Token',
                        value: val
                    });
                }
                return true;
            }
        },
        //基本信息
        Info: function (val) {
            if (!val) {
                //获取值
                var user = layui.data(app + 'User');
                return user.Info;
            } else {
                if (val == null) {
                    //删除值
                    layui.data(app + 'User', {
                        key: 'Info',
                        remove: true
                    });
                } else {
                    //设置值
                    layui.data(app + 'User', {
                        key: 'Info',
                        value: val
                    });
                }
                return true;
            }
        },
        //部门权限
        DeptPms: function (val) {
            if (!val) {
                //获取值
                var user = layui.data(app + 'User');
                return user.DeptPms;
            } else {
                if (val == null) {
                    //删除值
                    layui.data(app + 'User', {
                        key: 'DeptPms',
                        remove: true
                    });
                } else {
                    //设置值
                    layui.data(app + 'User', {
                        key: 'DeptPms',
                        value: val
                    });
                }
                return true;
            }
        },
        //1hr   2员工    3hr&员工
        Role: function () {

        },
        //功能权限
        RolePms: function (val) {
            if (!val) {
                //获取值
                var user = layui.data(app + 'User');
                return user.RolePms;
            } else {
                if (val == null) {
                    //删除值
                    layui.data(app + 'User', {
                        key: 'RolePms',
                        remove: true
                    });
                } else {
                    //设置值
                    layui.data(app + 'User', {
                        key: 'RolePms',
                        value: val
                    });
                }
                return true;
            }
        }

    },
    Data: {
        LoginHtml: function () {

        },
        Storage: function (key, val) {
            if (!val) {
                //获取值
                var stor = layui.data(app + 'Storage');
                return stor[key];
            } else {
                if (val == null) {
                    //删除值
                    layui.data(app + 'Storage', {
                        key: key,
                        remove: true
                    });
                } else {
                    //设置值
                    layui.data(app + 'Storage', {
                        key: key,
                        value: val
                    });
                }
                return true;
            }
        }

    },
    //method......
    Get2: function (url, data, callFunc) {
        // if (API)
        // {
        //     console.log(API);
        // }

        let JsonObj = { "Code": "-2", "Data": "{}", "Msg": "请求超时" };
        $.ajax({
            type: "get",
            async: false,
            url: common.backBaseApi(url) + url + "?&" + data,
            dataType: "json",
            headers: {
                "token": common.User.Token()
            },
            //jsonp: "callback", //传递给请求处理程序或页面的，用以获得jsonp回调函数名的参数名(一般默认为:callback)
            //jsonpCallback:"?",//自定义的jsonp回调函数名称，默认为jQuery自动生成的随机函数名，也可以写"?"，jQuery会自动为你处理数据
            success: function (res) {

                //console.log("999" - JsonObj.errorCode);
                if (res != undefined && res != "undefined" && res != null) {
                    if (typeof (res) == "string") {
                        JsonObj = JSON.parse(res);
                        // console.log("字符串");
                    } else {
                        JsonObj = res;
                        // console.log("对象");
                    }
                }
                if (common.isHave12300(JsonObj, url)) {
                    common.CheckLogin(0);
                    return;
                } else if (common.isHave400(JsonObj, url)) {
                    console.log(JsonObj)
                    location.href = "/html/msg/403.html?api=" + url;
                    return;

                } else {
                    callFunc(JsonObj);
                }
            },
            error: function (XMLHttpRequest, textStatus, errorThrown, data) {
                //alert("请求出错：" + errorThrown);
                common.LodingHide();
                console.log(XMLHttpRequest + textStatus + errorThrown + data);
                JsonObj = { "Code": "-3", "Data": "{}", "Msg": "请求出错" };
                callFunc(JsonObj);
            }
        });

    },

    //GET通用顶级获取数据方法
    Get: function (url, data, callFunc) {
        // if (API)
        // {
        //     console.log(API);
        // }
        let JsonObj = { "Code": "-2", "Data": "{}", "Msg": "请求超时" };
        $.ajax({
            type: "get",
            async: false,
            url: url + "?&" + data,
            dataType: "json",
            //jsonp: "callback", //传递给请求处理程序或页面的，用以获得jsonp回调函数名的参数名(一般默认为:callback)
            //jsonpCallback:"?",//自定义的jsonp回调函数名称，默认为jQuery自动生成的随机函数名，也可以写"?"，jQuery会自动为你处理数据
            success: function (res) {

                //console.log("999" - JsonObj.errorCode);
                if (res != undefined && res != "undefined" && res != null) {
                    if (typeof (res) == "string") {
                        JsonObj = JSON.parse(res);
                        // console.log("字符串");
                    } else {
                        JsonObj = res;
                        // console.log("对象");
                    }
                }
                if (common.isHave12300(JsonObj, url)) {
                    common.CheckLogin(0);
                    return;
                } else if (common.isHave400(JsonObj, url)) {
                    console.log(JsonObj)

                    location.href = "/html/msg/403.html?api=" + url;
                    return;

                } else {
                    callFunc(JsonObj);
                }
            },
            error: function (XMLHttpRequest, textStatus, errorThrown, data) {
                //alert("请求出错：" + errorThrown);
                common.LodingHide();
                console.log(XMLHttpRequest + textStatus + errorThrown + data);
                JsonObj = { "Code": "-3", "Data": "{}", "Msg": "请求出错" };
                callFunc(JsonObj);
            }
        });
    },
    ////--添、删、改 提交数据-- data为json字符串 
    Submit: function (url, data, callFunc) {
        let JsonObj = { "Code": "-2", "Data": "{}", "Msg": "请求超时" };
        var api = common.backBaseApi(url);
        if (url.indexOf("http") >= 0) {
            api = "";
        }
        var newUrl = "";
        if (url.indexOf("/") == 0) {
            newUrl = api + url;
        } else {
            if (api != "") {
                newUrl = api + "/" + url;
            } else {
                newUrl = url;
            }
        }

        if (newUrl.indexOf("#") < 0) {
            newUrl += "#";
        }
        var ul = newUrl.substring(0, newUrl.indexOf("#"));
        if (ul.indexOf("?") > 0) {
            ul += "&";
        } else {
            ul += "?";
        }
        ul += "";
        $.ajax({
            type: "post",
            async: false,
            url: ul,
            data: data,
            headers: {
                "token": common.User.Token()
            },
            contentType: 'application/json;charset=utf-8',
            //contentType: 'application/json',
            dataType: 'json',
            success: function (res) {
                //console.log("999" - JsonObj.errorCode);
                if (res != undefined && res != "undefined" && res != null) {
                    if (typeof (res) == "string") {
                        JsonObj = JSON.parse(res);
                        // console.log("字符串");
                    } else {
                        JsonObj = res;
                        // console.log("对象");
                    }
                }
                if (common.isHave12300(JsonObj, url)) {
                    common.CheckLogin(0);
                    return;
                } else if (common.isHave400(JsonObj, url)) {
                    console.log(JsonObj)

                    location.href = "/html/msg/403.html?api=" + url;
                    return;

                } else {
                    callFunc(JsonObj);
                }
            },
            error: function (XMLHttpRequest, textStatus, errorThrown, data) {
                //alert("请求出错：" + errorThrown);
                console.log(XMLHttpRequest + errorThrown + textStatus + data);
                JsonObj = { "Code": "-3", "Data": "{}", "Msg": "请求出错" };
                callFunc(JsonObj);
            }
        });
    },
    //-----获取数据-------------
    GetList: function (url, data, callFunc) {
        let JsonObj = { "Code": "-2", "Data": "{}", "Msg": "请求超时" };
        var api = common.backBaseApi(url);
        if (url.indexOf("http") >= 0) {
            api = "";
        }
        var newUrl = "";
        if (url.indexOf("/") == 0) {
            newUrl = api + url;
        } else {
            if (api != "") {
                newUrl = api + "/" + url;
            } else {
                newUrl = url;
            }
        }
        if (newUrl.indexOf("#") < 0) {
            newUrl += "#";
        }
        var ul = newUrl.substring(0, newUrl.indexOf("#"));
        if (ul.indexOf("?") > 0) {
            ul += "&";
        } else {
            ul += "?";
        }
        ul += "";
        $.ajax({
            type: "post",
            async: false,
            url: ul,
            data: data,
            headers: {
                "token": common.User.Token()
            },
            success: function (res) {
                if (res != undefined && res != "undefined" && res != null) {
                    if (typeof (res) == "string") {
                        JsonObj = JSON.parse(res);
                        // console.log("字符串");
                    } else {
                        JsonObj = res;
                        //console.log("对象");
                    }
                }

                if (common.isHave12300(JsonObj, url)) {
                    console.log(JsonObj)
                    common.CheckLogin(1);
                } else if (common.isHave400(JsonObj, url)) {
                    console.log(JsonObj);
                    location.href = "/html/msg/403.html?api=" + url;
                    return;
                } else {
                    callFunc(JsonObj);
                }
            },
            error: function (XMLHttpRequest, textStatus, errorThrown, data) {
                //alert("请求出错："+errorThrown);
                console.log(XMLHttpRequest + errorThrown + textStatus + data);
                JsonObj = { "Code": "-3", "Data": "{}", "Msg": "请求出错" };
                callFunc(JsonObj);
            }
        });



        //alert(obj);
        //return obj;
    },
    //Content-Type:application/x-www-form-urlencoded; charset=UTF-8
    GetList2: function (url, data, callFunc) {
        let JsonObj = { "Code": "-2", "Data": "{}", "Msg": "请求超时" };

        var api = common.backBaseApi(url);
        if (url.indexOf("http") >= 0) {
            api = "";
        }
        var newUrl = "";
        if (url.indexOf("/") == 0) {
            newUrl = api + url;
        } else {
            if (api != "") {
                newUrl = api + "/" + url;
            } else {
                newUrl = url;
            }
        }
        if (newUrl.indexOf("#") < 0) {
            newUrl += "#";
        }
        var ul = newUrl.substring(0, newUrl.indexOf("#"));
        if (ul.indexOf("?") > 0) {
            ul += "&";
        } else {
            ul += "?";
        }
        ul += "";
        $.ajax({
            type: "post",
            async: false,
            url: ul,
            data: data,
            headers: {
                "token": common.User.Token()
            },
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            success: function (res) {
                if (res != undefined && res != "undefined" && res != null) {
                    if (typeof (res) == "string") {
                        JsonObj = JSON.parse(res);
                        // console.log("字符串");
                    } else {
                        JsonObj = res;
                        //console.log("对象");
                    }
                }

                if (common.isHave12300(JsonObj, url)) {
                    console.log(JsonObj);
                    common.CheckLogin(1);
                } else if (common.isHave400(JsonObj, url)) {
                    console.log(JsonObj);
                    location.href = "/html/msg/403.html?api=" + url;
                    return;
                } else {
                    callFunc(JsonObj);
                }
            },
            error: function (XMLHttpRequest, textStatus, errorThrown, data) {
                //alert("请求出错："+errorThrown);
                console.log(XMLHttpRequest + errorThrown + textStatus + data);
                JsonObj = { "Code": "-3", "Data": "{}", "Msg": "请求出错" };
                callFunc(JsonObj);
            }
        });



        //alert(obj);
        //return obj;
    },
    //Promise方式的 Post通用方法
    PostPromise: function (url, data) {
        var promise = new Promise(function (successcb, failcb) {
            let JsonObj = { "Code": "-2", "Data": "{}", "Msg": "请求超时" };
            var api = common.backBaseApi(url);
            if (url.indexOf("http") >= 0) {
                api = "";
            }
            var newUrl = "";
            if (url.indexOf("/") == 0) {
                newUrl = api + url;
            } else {
                if (api != "") {
                    newUrl = api + "/" + url;
                } else {
                    newUrl = url;
                }
            }

            if (newUrl.indexOf("#") < 0) {
                newUrl += "#";
            }
            var ul = newUrl.substring(0, newUrl.indexOf("#"));
            if (ul.indexOf("?") > 0) {
                ul += "&";
            } else {
                ul += "?";
            }
            ul += "";
            $.ajax({
                type: "post",
                async: false,
                url: ul,
                data: JSON.stringify(data),
                headers: {
                    "token": common.User.Token()
                },
                contentType: 'application/json;charset=utf-8',
                //contentType: 'application/json',
                dataType: 'json',
                success: function (res) {
                    //console.log("999" - JsonObj.errorCode);
                    if (res != undefined && res != "undefined" && res != null) {
                        if (typeof (res) == "string") {
                            JsonObj = JSON.parse(res);
                            // console.log("字符串");
                        } else {
                            JsonObj = res;
                            // console.log("对象");
                        }
                    }
                    if (common.isHave12300(JsonObj, url)) {
                        common.CheckLogin(0);
                        return;
                    } else if (common.isHave400(JsonObj, url)) {
                        console.log(JsonObj)

                        location.href = "/html/msg/403.html?api=" + url;
                        return;

                    } else {
                        successcb(JsonObj);
                    }
                },
                error: function (XMLHttpRequest, textStatus, errorThrown, data) {
                    //alert("请求出错：" + errorThrown);
                    //console.log(XMLHttpRequest + errorThrown + textStatus + data);
                    JsonObj = { "Code": "-3", "Data": "{}", "Msg": "请求出错" + XMLHttpRequest + errorThrown + textStatus + data };
                    failcb(JsonObj);
                }
            });
        });
        return promise;
    },
    GetPromise: function (url, data) {
        var promise = new Promise(function (successcb, failcb) {
            let JsonObj = { "Code": "-2", "Data": "{}", "Msg": "请求超时" };
            var api = common.backBaseApi(url);
            if (url.indexOf("http") == 0) {
                api = "";
            }
            var newUrl = "";
            if (url.indexOf("/") == 0) {
                newUrl = api + url;
            } else {
                if (api != "") {
                    newUrl = api + "/" + url;
                } else {
                    newUrl = url;
                }
            }

            if (newUrl.indexOf("#") < 0) {
                newUrl += "#";
            }
            var ul = newUrl.substring(0, newUrl.indexOf("#"));
            if (ul.indexOf("?") > 0) {
                ul += "&";
            } else {
                ul += "?";
            }
            ul += "";
            $.ajax({
                type: "get",
                async: false,
                url: ul,
                data: JSON.stringify(data),
                headers: {
                    "token": common.User.Token()
                },
                contentType: 'application/json;charset=utf-8',
                //contentType: 'application/json',
                dataType: 'json',
                success: function (res) {
                    //console.log("999" - JsonObj.errorCode);
                    if (res != undefined && res != "undefined" && res != null) {
                        if (typeof (res) == "string") {
                            JsonObj = JSON.parse(res);
                            // console.log("字符串");
                        } else {
                            JsonObj = res;
                            // console.log("对象");
                        }
                    }
                    if (common.isHave12300(JsonObj, url)) {
                        common.CheckLogin(0);
                        return;
                    } else if (common.isHave400(JsonObj, url)) {
                        console.log(JsonObj)

                        location.href = "/html/msg/403.html?api=" + url;
                        return;

                    } else {
                        successcb(JsonObj);
                    }
                },
                error: function (XMLHttpRequest, textStatus, errorThrown, data) {
                    //alert("请求出错：" + errorThrown);
                    //console.log(XMLHttpRequest + errorThrown + textStatus + data);
                    JsonObj = { "Code": "-3", "Data": "{}", "Msg": "请求出错" + XMLHttpRequest + errorThrown + textStatus + data };
                    failcb(JsonObj);
                }
            });
        });
        return promise;
    },
    CheckLogin: (type) => {
        setTimeout(() => {



            //中软
            if (location.href.indexOf("yikq.chinasoftinc.com") >= 0) {


                try {
                    top.location.href = "http://49.4.4.70:8989/SignOnServlet";
                    return;
                } catch (error) {

                }
                // let height = $(window).height() - 130;
                // let login = common.OpenPage("http://49.4.4.70:8989/SignOnServlet", "登录已过期，请登录", ["100%", height + "px"], {
                //     title: false,
                //     closeBtn: 0,
                //     end: function() {
                //         if (type == 1) {
                //             location.reload();
                //         }
                //     }
                // });

                // try {
                //     layer.full(login);
                // } catch (error) {

                // }
            } else if (location.href.indexOf("ics.chinasoftinc.com") >= 0) {
                try {
                    top.location.href = "http://ics.chinasoftinc.com/SignOnServlet";
                    return;
                } catch (error) {

                }
            }
            //维他奶
            else if (location.href.indexOf("hrmt.vitasoy-chn.com") >= 0 || location.href.indexOf("hrms.vitasoy-chn.com") >= 0) {
                let api = "https://ssoportal-test.vitasoy-chn.com/frontend/enduser/#/enduser/index";
                if (location.href.indexOf("hrms.vitasoy-chn.com") >= 0) {
                    api = "https://sso.vitasoy-chn.com";
                }
                // if (location.href.indexOf("hrmd.vitasoy-chn.com") >= 0) {
                //     api = "https://ssoportal-test.vitasoy-chn.com/frontend/enduser/#/enduser/index";
                // }
                if (location.href.indexOf("hrmt.vitasoy-chn.com") >= 0) {
                    api = "https://ssoportal-test.vitasoy-chn.com/frontend/enduser/#/enduser/index";
                }
                // if (location.href.indexOf("hrme.vitasoy-chn.com") >= 0) {
                //     api = "https://ssoportal-test.vitasoy-chn.com/frontend/enduser/#/enduser/index";
                // }

                top.location.href = api;
                return;
            }
            //易HR SaaS
            else {




                let height = $(window).height() - 130;

                if (top != self) {

                    let tt = top;
                    let se = self;



                    let url = "/main/login.html?minlogin=1";
                    let title = "登录已过期，请登录";
                    let id = "openpage_" + MD5(url); //"openpage_" + url.replace(/\//g, "_").replace(/\?/g, "_").replace(/&/g, "_").replace(/\./g, "_")
                    let obj = {
                        id: id,
                        type: 2,
                        maxmin: false,
                        title: title,
                        area: ["95%", $(tt.window).height() * 0.9 + "px"],
                        content: url, //这里content是顶部引入的组件  注意type为1
                        cancel: function (index, layero) {
                            layero;
                            layer.close(index);
                            // if (confirm('确定要关闭么'))
                            // { //只有当点击confirm框的确定时，该层才会关闭
                            //     layer.close(index)
                            // }
                            return false;
                        },
                        end: function () {
                            //J.Alert("销毁了");
                            if (type == 1) {
                                se.location.reload();
                            }
                        }
                    }

                    let login = tt.layer.open(obj);

                    try {
                        //layer.full(login);
                        tt.layer.style(login, {
                            height: $(tt.window).height() * 0.9 + "px",
                            top: $(tt.window).height() * 0.1 / 2

                        });
                    } catch (error) {

                    }
                } else {
                    let login = common.OpenPage("/main/login.html?minlogin=1", "登录已过期，请登录", ["95%", height + "px"], {
                        end: function () {
                            if (type == 1) {
                                location.reload();
                            }
                        }
                    });
                    try {
                        //layer.full(login);
                        layer.style(login, {
                            height: $(window).height() * 0.9 + "px",
                            top: $(window).height() * 0.1 / 2

                        });
                    } catch (error) {

                    }
                }

            }

        }, 1000);
    },

    OpenDom: function (domstr, title, area, otherObj) {
        let layerObj = null;
        layui.use('layer', function () {
            var layer = layui.layer;


            let w = 'auto';
            let h = '500px';
            if (!area) {
                area = [w, h];
            } else {
                if (area[1] == "auto") {
                    area[1] = '500px';
                }
                if (area[1].indexOf("%") >= 0) {
                    area[1] = '500px';
                }
                if (parseInt(area[1].replace("px", "")) >= document.documentElement.clientHeight - 60 * 2) {
                    area[1] = '500px';
                }
            }
            if (parseInt(area[1].replace("px", "")) >= document.documentElement.clientHeight - 60 * 2) {
                area[1] = (document.documentElement.clientHeight - 60 * 2 - 10) * 1 + 'px';
            }

            let id = "opendom_" + MD5(domstr); // "opendom_" + domstr.replace(/#/g, "_").replace(/\//g, "_").replace(/\?/g, "_").replace(/&/g, "_").replace(/\./g, "_")

            // if($("#"+id)&&$("#"+id).length)
            // {
            //     $("#"+id).remove();
            // }

            let obj = {
                id: id,
                type: 1,
                maxmin: false,
                title: title,
                area: area,
                content: $(domstr), //这里content是顶部引入的组件  注意type为1
                cancel: function (index, layero) {
                    layero;
                    layer.close(index);
                    // if (confirm('确定要关闭么'))
                    // { //只有当点击confirm框的确定时，该层才会关闭
                    //     layer.close(index)
                    // }
                    return false;
                },
                end: function () {
                    //J.Alert("销毁了");
                    $(domstr).hide();
                }
            }
            let newObj = Object.assign(obj, otherObj)
            layerObj = layer.open(newObj);
            //layer.full(layerObj);
            return layerObj;

        });
        return layerObj;
    },
    OpenHtmlStr: function (html, title, area, otherObj) {
        let layerObj = null;
        layui.use('layer', function () {
            var layer = layui.layer;

            let w = 'auto';
            let h = '500px';
            if (!area) {
                area = [w, h];
            } else {
                if (area[1] == "auto") {
                    area[1] = '500px';
                }
                if (parseInt(area[1].replace("px", "")) >= document.documentElement.clientHeight - 60 * 2) {
                    area[1] = '500px';
                }
            }
            if (parseInt(area[1].replace("px", "")) >= document.documentElement.clientHeight - 60 * 2) {
                area[1] = (document.documentElement.clientHeight - 60 * 2 - 10) * 1 + 'px';
            }


            let id = "openhtml_" + MD5(html); //"openhtml_" + title.replace(/\//g, "_").replace(/\?/g, "_").replace(/&/g, "_").replace(/\./g, "_")
            let obj = {
                id: id,
                type: 1,
                maxmin: false,
                title: title,
                area: area,
                content: html, //这里content是顶部引入的组件  注意type为1
                cancel: function (index, layero) {
                    layero;
                    layer.close(index);
                    // if (confirm('确定要关闭么'))
                    // { //只有当点击confirm框的确定时，该层才会关闭
                    //     layer.close(index)
                    // }
                    return false;
                },
                end: function () {
                    //J.Alert("销毁了");
                    //$(domstr).hide();
                }
            }
            let newObj = Object.assign(obj, otherObj)
            layerObj = layer.open(newObj);

            return layerObj;
            //layer.full(layerObj);
        });
        return layerObj;
    },

    OpenPage: function (url, title, area, otherObj) {
        let layerObj = null;
        layui.use('layer', function () {
            var layer = layui.layer;

            let w = 'auto';
            let h = '500px';
            if (!area) {
                area = [w, h];
            } else {
                if (area[1] == "auto") {
                    area[1] = '500px';
                }
                if (area[1].indexOf("%") >= 0) {
                    area[1] = (document.documentElement.clientHeight - 10) * area[1] + 'px';
                }
                if (parseInt(area[1].replace("px", "")) >= document.documentElement.clientHeight - 10) {
                    (document.documentElement.clientHeight - 10) * 1 + 'px';
                }
            }
            if (parseInt(area[1].replace("px", "")) >= document.documentElement.clientHeight - 10) {
                area[1] = (document.documentElement.clientHeight - 10) * 1 + 'px';
            }

            let id = "openpage_" + MD5(url); //"openpage_" + url.replace(/\//g, "_").replace(/\?/g, "_").replace(/&/g, "_").replace(/\./g, "_")
            let obj = {
                id: id,
                type: 2,
                maxmin: false,
                title: title,
                area: area,
                content: url.replace("#", "?newid=" + MD5(Math.random().toString()) + "#"), //这里content是顶部引入的组件  注意type为1
                cancel: function (index, layero) {
                    layero;
                    layer.close(index);
                    // if (confirm('确定要关闭么'))
                    // { //只有当点击confirm框的确定时，该层才会关闭
                    //     layer.close(index)
                    // }
                    return false;
                },
                end: function () {
                    //J.Alert("销毁了");

                }
            }
            let newObj = Object.assign(obj, otherObj)
            layerObj = layer.open(newObj);

            return layerObj;
            //layer.full(layerObj);
        });
        return layerObj;
    },
    Alert: (title, icon, toDo) => {

        if (!title || title == "undefined" || title == undefined || title == null || title == "null") {
            title = "网络不太顺畅，请稍候再试";
        }
        layui.use('layer', function () {
            var layer = layui.layer;


            if (!icon) {
                icon = -1;
            }
            if (!toDo) {
                toDo = function () { }
            }
            var lay1 = layer.alert(title, { icon: icon },
                function () {
                    toDo();
                    layer.close(lay1);
                }
            );

        });
    },
    Msg: (title, time, fun) => {
        if (!title || title == "undefined" || title == undefined || title == null || title == "null") {
            title = "网络不太顺畅，请稍候再试";
        }

        let tm = 3000;
        if (location.href.indexOf("chinasoftinc") >= 0) {
            tm = 5000;
        }
        layui.use('layer', function () {

            if (!time) {
                time = tm;
            }
            var layer = layui.layer;
            layer.msg(title, {
                icon: -1,
                shade: 0.3,
                shadeClose: false,
                time: time //1.2秒关闭（如果不配置，默认是3秒）
            }, function () {
                //do something
                if (typeof fun == "function")
                    fun();
            });
        });
    },
    Confirm: (content, title, toDo, cancelDo, btns) => {

        if (!content || content == "undefined" || content == undefined || content == null || content == "null") {
            content = "网络不太顺畅，请稍候再试";
        }

        if (!title) {
            title = "信息"
        }
        if (!toDo) {
            toDo = function () { }
        }
        if (!cancelDo) {
            cancelDo = function () { }
        }
        if (!btns) {
            btns = ['确定', '取消']
        }
        //询问框
        layui.use('layer', function () {
            var layer = layui.layer;

            var lay1 = layer.confirm(content, {
                btn: btns,
                icon: -1,
                title: title,
                closeBtn: false,
            }, function () {
                console.log("确定了");
                toDo();
                layer.close(lay1);
            }, function () {
                console.log("取消了");
                cancelDo();
            });

        });
    },
    Confirm1: (content, title, toDo, cancelDo, btns, icon) => {

        if (!content || content == "undefined" || content == undefined || content == null || content == "null") {
            content = "网络不太顺畅，请稍候再试";
        }

        if (!title) {
            title = "信息"
        }
        if (!toDo) {
            toDo = function () { }
        }
        if (!cancelDo) {
            cancelDo = function () { }
        }
        if (!btns) {
            btns = ['确定', '取消']
        }
        //询问框
        layui.use('layer', function () {
            var layer = layui.layer;

            var lay1 = layer.confirm(content, {
                btn: btns,
                icon: icon,
                title: title,
                closeBtn: 1,
            }, function () {
                console.log("确定了");
                toDo();
                layer.close(lay1);
            }, function () {
                console.log("取消了");
                cancelDo();
            });

        });
    },

    Loding: (msg) => {
        layui.use('layer', function () {
            var layer = layui.layer;
            if (!msg) {
                layer.load(2);
            } else {
                layer.msg(msg, {
                    icon: 16,
                    shadeClose: false,
                    shade: 0.01
                });
            }

        });
    },
    LodingHide: () => {
        layui.use('layer', function () {
            var layer = layui.layer;
            layer.closeAll('loading');
        });
    },


    ParseForm: function (layui_form) {
        var form = layui_form;
        var formon = form.on;
        form.on = function (events, callback, boxJqObj) {
            let that = this;
            let resObj;
            let selfName = "";
            if (boxJqObj && boxJqObj.length) {
                let filters = events.match(/\((.*)\)$/) || [] //提取事件过滤器字符结构，如：select(xxx)
                let filterName = filters[1] || '';
                let type = events.replace(filters[0], '');

                if (filterName == "") {
                    filterName = "_filter_" + new Date().getTime() + '_' + Math.floor(Math.random() * 100000);
                } else {
                    selfName = filterName.toString();
                    filterName += "_filter_selef_" + new Date().getTime() + '_' + Math.floor(Math.random() * 100000);
                }


                if (type == "select") {

                    filterName = "sel_" + filterName;
                    $(boxJqObj).find(type).each(function () {
                        if ($(this).attr('lay-filter') && $(this).attr('lay-filter').length) {
                            if ($(this).attr('lay-filter').indexOf("_filter_") >= 0) {
                                //自定义名称 需要保留原样 不能被覆盖 第一步  
                            }
                            if ($(this).attr('lay-filter') == selfName) {
                                //自定义名称 需要保留原样 不能被覆盖   第二步
                                $(this).attr('lay-filter', filterName);
                            }
                        } else {
                            $(this).attr('lay-filter', filterName);
                        }

                    });
                }

                //待完善    其他类型也应该跟select一样加上自定义名称逻辑
                if (type == "checkbox") {
                    filterName = "ck_" + filterName;
                    $(boxJqObj).find("input[type='checkbox']").each(function () {
                        //$(this).attr('lay-filter', filterName);

                        //console.log($(this));
                        if ($(this).attr('lay-skin') != "switch") {
                            if ($(this).attr('lay-filter') && $(this).attr('lay-filter').length) {
                                if ($(this).attr('lay-filter').indexOf("_filter_") >= 0) {
                                    //自定义名称 需要保留原样 不能被覆盖 第一步  
                                }
                                if ($(this).attr('lay-filter') == selfName) {
                                    //自定义名称 需要保留原样 不能被覆盖   第二步
                                    $(this).attr('lay-filter', filterName);
                                }
                            } else {
                                $(this).attr('lay-filter', filterName);
                            }

                        }

                    });
                }
                if (type == "radio") {
                    filterName = "ra_" + filterName;
                    $(boxJqObj).find(":radio").each(function () {
                        if ($(this).attr('lay-filter') && $(this).attr('lay-filter').length) {
                            if ($(this).attr('lay-filter').indexOf("_filter_") >= 0) {
                                //自定义名称 需要保留原样 不能被覆盖 第一步  
                            }
                            if ($(this).attr('lay-filter') == selfName) {
                                //自定义名称 需要保留原样 不能被覆盖   第二步
                                $(this).attr('lay-filter', filterName);
                            }
                        } else {
                            $(this).attr('lay-filter', filterName);
                        }
                    });
                }
                if (type == "switch") {
                    filterName = "sw_" + filterName;
                    $(boxJqObj).find(":checkbox").each(function () {
                        if ($(this).attr('lay-skin') == "switch") {
                            if ($(this).attr('lay-filter') && $(this).attr('lay-filter').length) {
                                if ($(this).attr('lay-filter').indexOf("_filter_") >= 0) {
                                    //自定义名称 需要保留原样 不能被覆盖 第一步  
                                }
                                if ($(this).attr('lay-filter') == selfName) {
                                    //自定义名称 需要保留原样 不能被覆盖   第二步
                                    $(this).attr('lay-filter', filterName);
                                }
                            } else {
                                $(this).attr('lay-filter', filterName);
                            }
                        }
                    });
                }
                if (type == "submit") {
                    filterName = "sub_" + filterName;
                    $(boxJqObj).find("submit,button,input[type='button'],input[type='submit']").each(function () {
                        if ($(this).attr('lay-filter') && $(this).attr('lay-filter').length) {
                            if ($(this).attr('lay-filter').indexOf("_filter_") >= 0) {
                                //自定义名称 需要保留原样 不能被覆盖 第一步  
                            }
                            if ($(this).attr('lay-filter') == selfName) {
                                //自定义名称 需要保留原样 不能被覆盖   第二步
                                $(this).attr('lay-filter', filterName);
                            }
                        } else {
                            $(this).attr('lay-filter', filterName);
                        }
                    });
                }

                let eventsNew = type + "(" + filterName + ")";
                resObj = formon.call(that, eventsNew, callback);
            } else {
                resObj = formon.call(that, events, callback);
            }
            return resObj;
        };



        return form;
    },
    ParseTree: function (oldTree, newTree, map = { id: "deptId", name: "deptName", pid: "parentDeptId", children: "children" }) {
        let newTree1 = newTree;
        for (var i = 0; i < oldTree.length; i++) {

            if (newTree1.length == 0) {
                newTree1 = {
                    id: -2,
                    title: "选择",
                    //*其他自定义参数
                    //*其他自定义参数
                    parent: -2,
                    spread: true,
                    children: [
                        //--------

                        //--------
                    ]
                }
            }

            var newrow = {
                id: oldTree[i].id || oldTree[i][map.id],
                title: oldTree[i].title || oldTree[i][map.name],
                //*其他自定义参数
                //*其他自定义参数
                parent: oldTree[i].parent || oldTree[i][map.pid],
                spread: oldTree[i].spread || oldTree[i][map.pid] == 0 ? true : false,
                //checked:oldTree[i].parentDeptId==0?true:false,
                children: [
                    //--------

                    //--------
                ]
            }
            if (!oldTree[i][map.children] || oldTree[i][map.children].length == 0) {

                newTree1.children.push(newrow);
            } else {
                common.ParseTree(oldTree[i][map.children], newrow, map);
                newTree1.children.push(newrow);
            }
        }

        return newTree1.children;
    },



    //<ww-open-data type="departmentName" openid="'+data.deptName+'"></ww-open-data>
    ParseTreeQyWxDept: function (oldTree, newTree, map = { id: "deptId", name: "deptName", pid: "parentDeptId", children: "children" }) {
        let newTree1 = newTree;
        for (var i = 0; i < oldTree.length; i++) {

            if (newTree1.length == 0) {
                newTree1 = {
                    id: -2,
                    title: "选择",
                    //*其他自定义参数
                    //*其他自定义参数
                    parent: -2,
                    spread: true,
                    children: [
                        //--------

                        //--------
                    ]
                }
            }

            var newrow = {
                id: oldTree[i].id || oldTree[i][map.id],
                title: oldTree[i].title || oldTree[i][map.name],
                //*其他自定义参数
                //*其他自定义参数
                parent: oldTree[i].parent || oldTree[i][map.pid],
                spread: oldTree[i].spread || oldTree[i][map.pid] == 0 ? true : false,
                //checked:oldTree[i].parentDeptId==0?true:false,
                children: [
                    //--------

                    //--------
                ]
            }

            newrow.title = '<ww-open-data type="departmentName" openid="' + newrow.title + '"></ww-open-data>';
            if (!oldTree[i][map.children] || oldTree[i][map.children].length == 0) {

                newTree1.children.push(newrow);
            } else {
                common.ParseTreeQyWxDept(oldTree[i][map.children], newrow, map);
                newTree1.children.push(newrow);
            }
        }

        return newTree1.children;
    },

    ParseTree2: function (oldTree, newTree, map = { id: "deptId", name: "deptName", pid: "parentDeptId", children: "children" }) {
        let newTree1 = newTree;
        for (var i = 0; i < oldTree.length; i++) {

            if (newTree1.length == 0) {
                newTree1 = {
                    id: -2,
                    label: "选择",
                    //*其他自定义参数
                    //*其他自定义参数
                    parent: -2,
                    spread: true,
                    children: [
                        //--------

                        //--------
                    ]
                }
            }

            var newrow = {
                id: oldTree[i].id || oldTree[i][map.id],
                label: oldTree[i].title || oldTree[i][map.name],
                //*其他自定义参数
                //*其他自定义参数
                isLeaf: false,
                parent: oldTree[i].parent || oldTree[i][map.pid],
                spread: oldTree[i].spread || oldTree[i][map.pid] == 0 ? true : false,
                //checked:oldTree[i].parentDeptId==0?true:false,
                children: [
                    //--------

                    //--------
                ]
            }
            if (oldTree[i].deptChildNodeNum == 0) {

                newrow.isLeaf = true;
            }

            if (!oldTree[i][map.children] || oldTree[i][map.children].length == 0) {

                newTree1.children.push(newrow);
            } else {
                newrow.isLeaf = false;
                common.ParseTree2(oldTree[i][map.children], newrow, map);

                newTree1.children.push(newrow);
            }
        }

        return newTree1.children;
    },

    SearchTree: function (oldTree, newTree, map = { id: "deptId", name: "deptName", pid: "parentDeptId", children: "children" }, title, key) {
        if (!map || map == "" || map == []) {
            map = { id: "deptId", name: "deptName", pid: "parentDeptId", children: "children" }
        }
        let newTree1 = newTree;
        if (!newTree1 || newTree1 == "" || newTree1 == []) {
            newTree1 = {
                id: -2,
                title: "选择",
                //*其他自定义参数
                //*其他自定义参数
                parent: -2,
                spread: true,
                children: [
                    //--------
                    //--------
                ]
            }
        }

        for (var i = 0; i < oldTree.length; i++) {
            let text = oldTree[i].title || oldTree[i][map.name];
            let title1 = title || "";
            title1 += "/" + text;
            var newrow = {
                id: oldTree[i].id || oldTree[i][map.id],
                title: ("//" + title1).replace("///", "").replace("//", ""),
                //*其他自定义参数
                //*其他自定义参数
                parent: oldTree[i].parent || oldTree[i][map.pid],
                spread: oldTree[i].spread || oldTree[i][map.pid] == 0 ? true : false,
                //checked:oldTree[i].parentDeptId==0?true:false,
                children: [
                    //--------
                    //--------
                ]
            }
            if (!oldTree[i][map.children] || oldTree[i][map.children].length == 0) {
                if (text.toLocaleLowerCase().indexOf(key.toLocaleLowerCase()) >= 0) {
                    newTree1.children.push(newrow);
                    //title1 = "";
                } else {

                }
            } else {
                if (text.toLocaleLowerCase().indexOf(key.toLocaleLowerCase()) >= 0) {
                    newTree1.children.push(newrow);
                    //title1 = "";
                } else {

                }
                common.SearchTree(oldTree[i][map.children], newTree1, map, title1, key);
            }


        }

        return newTree1.children;
    },


    Exit: () => { },
    Pms: {
        UserPms: [],
        Node: function (json, row, url) {
            if (common.Pms.UserPms.length > 0) {
                return
            }

            for (var i = 0; i < json.length; i++) {
                if (common.Pms.UserPms.length > 0) {
                    return
                }
                if (!json[i].url) {
                    continue;
                }
                if (url.toLocaleLowerCase().indexOf(json[i].url.toLocaleLowerCase()) >= 0) {
                    if (json[i].parentId != 0) {
                        common.Pms.UserPms = json[i].childsList;
                    }
                }
                var newrow = {
                    id: json[i].id,
                    name: json[i].menu_Name,
                    //*其他自定义参数
                    //*其他自定义参数
                    dom: json[i].domStr,
                    pid: json[i].parentId,
                    order: json[i].seq_No,
                    url: json[i].url,
                    ioc: json[i].ioc,
                    type: json[i].menu_Type,
                    isMust: json[i].isMust,
                    spread: false,
                    children: []
                }
                if (!json[i].childsList) {
                    row.children.push(newrow);
                } else {
                    common.Pms.Node(json[i].childsList, newrow, url);
                    row.children.push(newrow);
                }
            }
            //console.log(row);
        },
        GetPms: function () {
            var obj = {};
            try {
                var url = '';
                var pms = common.User.RolePms();
                if (url.indexOf("PageSet") >= 0) {
                    pms = []; //设置左侧通用 不按页面划分
                }
                var doc = {
                    name: "顶级",
                    spread: true,
                    children: []
                };
                //----获取当前页的权限数据------------
                common.Pms.UserPms = [];
                common.Pms.Node(pms, doc, url);
                var TreeJson = common.Pms.UserPms;
                //----------------------
                //console.log(TreeJson);
                for (var i = 0; i < TreeJson.length; i++) {
                    if (TreeJson[i].isHavePrivilege == 0 && TreeJson[i].domStr != "") {
                        if (TreeJson[i].domStr == "###") {
                            continue;
                        }
                        obj[TreeJson[i].domStr] = false;
                    } else if (TreeJson[i].isHavePrivilege == 1 && TreeJson[i].domStr != "") {
                        if (TreeJson[i].domStr == "###") {
                            continue;
                        }
                        obj[TreeJson[i].domStr] = true;
                    }
                    //alert(i);
                }
            } catch (error) {
                console.log(error);
            }
            //console.log(obj);
            return obj;
        },
    },
    //验证是否需要审批流程  approCom 公用选审批人组件
    checkFlowState: function (params, callback, approCom = { domId: "", area: [], isEmpLogin: false }, openIndex = 1) {
        //flowType, empId, deptId, positionLevelId,
        //sourceType: flowType,
        //empId: empId,
        //deptId: deptId,
        //positionLevelId: positionLevelId || "" 

        let url = API.commonApi.getFlowControlState;

        if (approCom.isEmpLogin) {
            url = url.replace("jhtml", "empweb");
        }

        common.Submit(url, JSON.stringify(params), function (res) {
            if (res.suc) {
                callback(res.result.data.examType, []);
                if (res.result.data.examType == Constant.APPROVAL_FLOW.OPTIONAL_APPROVAL) {
                    openIndex = common.OpenDom("#" + approCom.domId, "自选审批人", approCom.area);
                }
            } else {
                common.Msg(res.msg);
            }
        });
        return openIndex;
    },
    Request: {
        Url: function () {
            return location.href;
        },
        QueryWithUrl: function (url, name) {
            //var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
            //var r = window.location.search.substr(1).match(reg);
            //if (r != null) return unescape(r[2]); return "";
            var reg = new RegExp("[\?\&]" + name + "=([^\&]+)", "i");

            //debugger;
            //let search = url.substr(url.indexOf("?") + 1)
            var result = url.match(reg);
            if (result == null || result.length < 1) {
                return null;
            }
            return decodeURI(result[1]);
        },
        Query: function (name) {
            //var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
            //var r = window.location.search.substr(1).match(reg);
            //if (r != null) return unescape(r[2]); return "";
            var reg = new RegExp("[\?\&]" + name + "=([^\&]+)", "i");
            var result = location.search.match(reg);
            if (result == null || result.length < 1) {
                return null;
            }
            return decodeURI(result[1]);
        },
        HasQuery: function (url, name) {
            if (common.Request.QueryWithUrl(url, name) != null) {
                return true;
            }
            return false;
        },
        //queryList ---[{key:name,value:aaaa},{key:phone,value:111}]
        ParseUrl: function (url, queryList) {
            if (!queryList || queryList.length <= 0) {
                return url;
            }

            for (let index = 0; index < queryList.length; index++) {
                let q1 = queryList[index];
                if (common.Request.HasQuery(url, q1.key)) {
                    //如果URL本身带值  但是queryList也有值 则用queryList值覆盖初始值
                    let defVal = common.Request.QueryWithUrl(url, q1.key);
                    url = url.replace(q1.key + "=" + defVal, q1.key + "=" + q1.value);
                    continue;
                } else {
                    if (url.indexOf("?") >= 0) {
                        url += "&" + q1.key + "=" + q1.value;
                    } else {
                        url += "?" + q1.key + "=" + q1.value;
                    }
                }
            }
            return url;

        }
    },
    //常量
    Constant: Constant,
    //关闭弹框
    Cancel: function (that) {
        layui.use('layer', function () {
            let layer = layui.layer;
            layer.close(that.openIndex);
        });
    },
    GetMenu: function (call) {



        if (location.href.indexOf("/personal/") >= 0) {

            let empMenuApi = "/static/data/empmenus.json";
            if (common.GetSystem().sys == common.GetSystem().doc.zr_emp) {
                empMenuApi = "/static/data/empmenus_zhongruan.json";
            }
            if (common.GetSystem().sys == common.GetSystem().doc.vt_emp) {
                empMenuApi = "/static/data/empmenus_vt.json";
            }
            common.Get(empMenuApi, {},
                function (res0) {


                    //debugger;
                    if (res0 && res0.errorCode != undefined && res0.errorCode.length) {
                        if (res0.errorCode == 0 || res0.errorCode.indexOf("成功") > -1) {
                            //获取菜单  组织菜单
                            let menus = res0.data;


                            common.Data.Storage("sys_menus", menus);
                            // menus.forEach(row =>
                            // {
                            //     // if (row.id == "19212823674880" &&row.childsList&&row.childsList.length&&row.childsList.length>0)
                            //     // {
                            //         common.Data.Storage("sys_menus", row.childsList.sort(by('seq_No', by('id'))));
                            //     //}
                            // });
                            call();
                        }
                    } else {

                    }

                });
        } else {
            let cacheMenu = common.Data.Storage("sys_menus");
            if (!cacheMenu || cacheMenu == null || cacheMenu.length <= 0) {


                common.Submit(API.main.hasMenu, JSON.stringify({ menu_Type: 1, parentId: 19212823674880 }), function (res0) {
                    if (res0 && res0.errorCode != undefined && res0.errorCode.length) {
                        if (res0.errorCode == 0 || res0.errorCode.indexOf("成功") > -1) {
                            //获取菜单  组织菜单
                            let menus = res0.result.data;


                            // menus.forEach(row =>
                            // {
                            //     // if (row.id == "19212823674880" &&row.childsList&&row.childsList.length&&row.childsList.length>0)
                            //     // {
                            //         common.Data.Storage("sys_menus", row.childsList.sort(by('seq_No', by('id'))));
                            //     //}
                            // });
                            common.Submit(API.main.findEscapeState,
                                JSON.stringify({}),
                                function (res) {
                                    // 如果返回没有权限和token失效的情况,和正常的业务逻辑返回数据结构不一样
                                    if (res.errorCode != undefined && res.errorCode == 0) {

                                        if (res.result.isOpen) {
                                            let newMenu = [];
                                            menus.forEach(row => {
                                                if (row.menu_Name.search("审批") >= 0 ||
                                                    row.menu_Name.search("设置") >= 0 || row.menu_Name.search("企微月报") >= 0 || row.menu_Name.search("合同") >= 0 || row.menu_Name.search("社保") >= 0 || row.menu_Name.search("商保") >= 0) { } else {
                                                    newMenu.push(row);
                                                }
                                            });
                                            common.Data.Storage("sys_menus", newMenu.sort(by('seq_No', by('id'))));
                                            call();
                                        } else {
                                            let newMenu = [];
                                            if (res.result.corpId == "") {
                                                menus.forEach(row => {
                                                    if (row.menu_Name.search("企微月报") < 0) {
                                                        newMenu.push(row);

                                                    }
                                                });
                                                common.Data.Storage("sys_menus", newMenu.sort(by('seq_No', by('id'))));
                                                call();
                                            } else {
                                                common.Data.Storage("sys_menus", menus.sort(by('seq_No', by('id'))));
                                                call();
                                            }


                                        }
                                    } else {
                                        if (res.msg != undefined) {
                                            common.Msg(res.msg);
                                        }
                                        if (res.message != undefined) {
                                            common.Msg(res.message);
                                        }

                                    }

                                });
                        }
                    } else {
                        call();
                    }
                });
            } else {
                call();
            }
        }
    },

    GetSystem: function () {
        let url = location.href.toLocaleLowerCase();
        let sys = 1;
        let doc = {
            yi_hr: 1, //易HR管理端
            yi_emp: 2, //易HR员工端
            yi_notice: 3, //通知必达

            zr_hr: 5, //中软HR端
            zr_emp: 6, //中软员工端


            vt_hr: 7, //维他奶HR端
            vt_emp: 8 //维他奶员工端
        }
        //中软 --本地调试时  若需要判断到中软 则增加 || 条件命中到即可
        if (url.indexOf("chinasoftinc.com") >= 0 || url.indexOf("139.9.143.33") >= 0) {
            if (url.indexOf("/personal/") >= 0) {
                sys = 6;
            } else {
                sys = 5;
            }
        } else if (url.indexOf("vitasoy-chn.com") >= 0) {
            if (url.indexOf("/personal/") >= 0) {
                sys = 8;
            } else {
                sys = 7;
            }
        } else if (url.indexOf(":12345") >= 0 || url.indexOf("notify.ctgpayroll.com") >= 0) {
            sys = 3;
        } else {

            if (url.indexOf("/personal/") >= 0) {
                sys = 2;
            } else {
                sys = 1;
            }

        }

        return {
            sys: sys,
            doc: doc
        }


    },





    //------------------------------以下notice项目------------------------------------------------------------




    //-----获取数据-------------
    NoticeGetList: function (url, data, callFunc) {
        let JsonObj = { "Code": "-2", "Data": "{}", "Msg": "请求超时" };

        var api = NoticeApi.apiBase;
        if (url.indexOf("http") >= 0) {
            api = "";
        }
        var newUrl = "";
        if (url.indexOf("/") == 0) {
            newUrl = api + url;
        } else {
            if (api != "") {
                newUrl = api + "/" + url;
            } else {
                newUrl = url;
            }
        }
        if (newUrl.indexOf("#") < 0) {
            newUrl += "#";
        }
        var ul = newUrl.substring(0, newUrl.indexOf("#"));
        if (ul.indexOf("?") > 0) {
            ul += "&";
        } else {
            ul += "?";
        }
        ul += "";
        $.ajax({
            type: "post",
            async: false,
            url: ul,
            data: data,
            headers: {
                "TOKEN": common.GetNoticeToken()
            },
            contentType: 'application/json;charset=utf-8',
            success: function (res) {
                if (res != undefined && res != "undefined" && res != null) {
                    if (typeof (res) == "string") {
                        JsonObj = JSON.parse(res);
                        // console.log("字符串");
                    } else {
                        JsonObj = res;
                        //console.log("对象");
                    }
                }

                if (["400201", "400202", "400203", "400207"].indexOf(JsonObj.code) >= 0 || JsonObj.code.indexOf("ILLEGAL_REQUEST") > -1 || JsonObj.code.indexOf("AUTHENTICATION_FAIL") > -1) {
                    console.log(JsonObj)
                    common.CheckLogin(1);
                } else if (JsonObj.code == 500009) {
                    console.log(JsonObj);
                    location.href = "/html/msg/403.html?api=" + url;
                    return;
                } else {
                    callFunc(JsonObj);
                }
            },
            error: function (XMLHttpRequest, textStatus, errorThrown, data) {
                //alert("请求出错："+errorThrown);
                console.log(XMLHttpRequest + errorThrown + textStatus + data);
                JsonObj = { "Code": "-3", "Data": "{}", "Msg": "请求出错" };
                callFunc(JsonObj);
            }
        });



        //alert(obj);
        //return obj;
    },
















    ////--添、删、改 提交数据-- data为json字符串 
    NoticeSubmit: function (url, data, callFunc) {
        let JsonObj = { "Code": "-2", "Data": "{}", "Msg": "请求超时" };
        var api = NoticeApi.apiBase;
        if (url.indexOf("http") >= 0) {
            api = "";
        }
        var newUrl = "";
        if (url.indexOf("/") == 0) {
            newUrl = api + url;
        } else {
            if (api != "") {
                newUrl = api + "/" + url;
            } else {
                newUrl = url;
            }
        }

        if (newUrl.indexOf("#") < 0) {
            newUrl += "#";
        }
        var ul = newUrl.substring(0, newUrl.indexOf("#"));
        if (ul.indexOf("?") > 0) {
            ul += "&";
        } else {
            ul += "?";
        }
        ul += "";
        $.ajax({
            type: "post",
            async: false,
            url: ul,
            data: data,
            headers: {
                "TOKEN": common.GetNoticeToken()
            },
            contentType: 'application/json;charset=utf-8',
            //contentType: 'application/json',
            dataType: 'json',
            success: function (res) {
                //console.log("999" - JsonObj.errorCode);
                if (res != undefined && res != "undefined" && res != null) {
                    if (typeof (res) == "string") {
                        JsonObj = JSON.parse(res);
                        // console.log("字符串");
                    } else {
                        JsonObj = res;
                        // console.log("对象");
                    }
                }
                if (["400201", "400202", "400203", "400207"].indexOf(JsonObj.code) >= 0 || JsonObj.code.indexOf("AUTHENTICATION_FAIL") > -1 || JsonObj.code.indexOf("ILLEGAL_REQUEST") > -1) {
                    console.log(JsonObj)
                    common.CheckLogin(0);
                } else if (JsonObj.code == 500009) {
                    console.log(JsonObj)

                    location.href = "/html/msg/403.html?api=" + url;
                    return;

                } else {
                    callFunc(JsonObj);
                }
            },
            error: function (XMLHttpRequest, textStatus, errorThrown, data) {
                //alert("请求出错：" + errorThrown);
                console.log(XMLHttpRequest + errorThrown + textStatus + data);
                JsonObj = { "Code": "-3", "Data": "{}", "Msg": "请求出错" };
                callFunc(JsonObj);
            }
        });
    },


    GetMenuNotice: function (call) {

        let cacheMenu = common.Data.Storage("sys_menus");
        if (!cacheMenu || cacheMenu == null || cacheMenu.length <= 0) {
            common.NoticeSubmit("/sso/menu/list/tree.ajax", JSON.stringify({ menu_Type: 1, parentId: 0 }), function (res0) {
                if (res0 && res0.code.length) {
                    if (res0.code == 0 || res0.code.indexOf("成功") > -1 || res0.code.indexOf("SUCCESS") > -1) {
                        //获取菜单  组织菜单
                        let menus = res0.data;

                        common.Data.Storage("sys_menus", menus.sort(by('seq_No', by('id'))));
                        // menus.forEach(row =>
                        // {
                        //     // if (row.id == "19212823674880" &&row.childsList&&row.childsList.length&&row.childsList.length>0)
                        //     // {
                        //         common.Data.Storage("sys_menus", row.childsList.sort(by('seq_No', by('id'))));
                        //     //}
                        // });
                        call();
                    }
                } else {
                    call();
                }
            });

        } else {
            call();
        }
    },




    //获取菜单 type = 1  子集  type != 1  自己
    GetMenuById: function (menuId, callback, type = 1) {
        let menu = common.User.RolePms();
        if (type == 1) {
            //查询对应的权限 
            common.SelectMenu(menu, menuId, (res) => {
                callback(res);
            });
        } else {
            //查询对应的权限 
            common.SelectMenu2(menu, menuId, (res) => {
                callback(res);
            });
        }

    },
    //根据id获取查询子集
    SelectMenu(list, id, callback) {
        let childsList = [];
        if (list) {
            for (let i = 0; i < list.length; i++) {
                let e = list[i];
                if (e.id == id) {
                    childsList = e.childsList;

                } else if (e.childsList != undefined && e.childsList.length > 0) {
                    this.SelectMenu(e.childsList, id, callback);
                }
            }
        }
        if (childsList.length > 0) {
            callback(childsList);
        }
    },
    //根据id获取查询当前
    SelectMenu2(list, id, callback) {
        let bean;
        for (let i = 0; i < list.length; i++) {
            let e = list[i];
            if (e.id == id) {
                bean = e;
            } else if (e.childsList.length > 0) {
                this.SelectMenu2(e.childsList, id, callback);
            }
        }
        if (bean) {
            callback(bean);
        }
    },

    //获取当前页面是不是有权限
    WhetherOrNotAuthorized(isUpdate, domStr) {
        let menuId = isUpdate == 1 ? common.Constant.EMP_DETAIL.UPDATE : common.Constant.EMP_DETAIL.VIEW;
        let isTrue = true;
        common.GetMenuById(menuId, (res) => {
            res.forEach((e) => {
                if (e.domStr == domStr && e.isHavePrivilege == 0) {
                    isTrue = false;
                }
            });
        });
        return isTrue;
    },
    //错误跳转页面
    ErrorDispose(_this) {
        location.href = "/html/msg/403.html?api=";
    },
    //获取通知token
    GetNoticeToken() {
        return common.User.Token();
    },
    GoBack(_this, times = 0, num = -1) {
        setTimeout(() => {
            window.history.length > 1 ?
                _this.$router.go(num) :
                _this.$router.push('/');
        }, times);

        let paths = common.Data.Storage("paths");
        paths.splice(0, 0 - num);
        common.Data.Storage("paths", paths);
    },
    JQuery(dom) {
        return $(dom);
    },

    //根据当前页面判断 是员工端还是企业端  url 进行修改
    IfAddressTheSuffix(_this, url) {
        if (_this.$route.path.indexOf("/personal/") === 0)
            return url.substring(0, url.lastIndexOf(".jhtml")) + '.empweb';
        return url;
    },
    isJSON(str) {
        if (typeof str == 'string') {
            try {
                var obj = JSON.parse(str);
                if (typeof obj == 'object' && obj) {
                    return true;
                } else {
                    return false;
                }

            } catch (e) {
                console.log('error：' + str + '!!!' + e);
                return false;
            }
        }
        console.log('It is not a string!')
    },


    //根据不同环境，切换适用范围组件. config:通用适用范围组件配置，zr_config:中软通用适用范围组件配置
    SwitchDeptComp(callback, zr_callback, zr_config, title = "适用范围", area = ["800px", "500px"]) {
        let currentSys = common.GetSystem();

        switch (currentSys.sys) {
            case currentSys.doc.zr_hr:
            case currentSys.doc.zr_emp:
            case currentSys.doc.vt_hr:
            case currentSys.doc.vt_emp:
                common.DeptCompByZR(zr_config, title, area, zr_callback);
                break;
            // case currentSys.doc.vt_hr://维他奶环境需求20210519
            //     if(location.href.indexOf("/set/approval/advanceapproval/flowlist")>0){
            //         common.DeptCompByZR(zr_config, title, area, zr_callback);
            //     }
            //     else{
            //         callback && callback();
            //     }
            //     break;
            default:
                callback && callback();
                break;
        }
    },
    //中软通用适用范围组件调用：title:弹窗标题, area：弹窗高宽数组, callback 回调方法
    DeptCompByZR(config, title, area, callback) {

        //设置缓存
        localStorage.setItem("dept_tiling_config", JSON.stringify(config));

        let obj = common.OpenPage("/#/company/depttiling?getDataType=2", title, area, {
            end: function () {
                if (typeof callback == "function") {
                    let res = [];
                    try {
                        res = JSON.parse($("#DeptTilingCallBack").text())
                    } catch {
                        console.log(res);
                    }

                    callback(res);
                }
            }
        });

        try {

            layui.layer.full(obj);

        } catch {

        }
    },
    //判断运行环境  1正式 2中软 3维他奶
    IfRuntimeEnvironment() {
        if (document.domain.indexOf("vitasoy-chn.com") > -1)
            return 3;
        else if (document.domain.indexOf("yikq.chinasoftinc.com") > -1 ||
            document.domain.indexOf("ics.chinasoftinc.com") > -1 ||
            document.domain.indexOf("139.9.143.33") > -1 ||
            document.domain.indexOf("192.168.160.29") > -1)
            return 2;
        else
            return 1;
    },
    //获取系统时间
    GetSysDate: function () {
        let sysDate = DateUtil.DateFormat(new Date(), DateUtil.FormatType3);

        this.Submit(API.editEmpApi.getSysDate, JSON.stringify({}), function (res) {
            if (res.suc) {
                sysDate = res.result.data;
            } else {
                common.Msg(res.msg);
            }
        });
        return sysDate;
    },
    // 没安装通讯录,调用翻译组件时之前需要登记第三方应用的身份信息
    RetranslationInfoBeforeAuthorized: function (morUrl, callback) {
        let that = this;
        var morFlagAuthor = 'morFlagAuthor';
        var morFlagUrl = 'morFlagUrl';
        let marignUrl = morUrl.split('#')[0];
        if (jsCookie.get(morFlagAuthor) == undefined || jsCookie.get(morFlagUrl) == undefined || jsCookie.get(morFlagUrl) != marignUrl) {
            that.GetPromise(API.main.getAuthInfo + '?url=' + marignUrl).then(result => {
                if (result.code == '0') {
                    let configDic = {
                        timestamp: result.data.timestamp, // 必填，生成签名的时间戳
                        nonceStr: result.data.noncestr, // 必填，生成签名的随机串
                        signature: result.data.signature,// 必填，签名，见附录-JS-SDK使用权限签名算法
                        jsApiList: ['selectExternalContact'], //必填，传入需要使用的接口名称
                    };
                    if (/MicroMessenger/i.test(navigator.userAgent)) {
                        wx.config({
                            beta: true,// 必须这么写，否则wx.invoke调用形式的jsapi会有问题
                            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                            appId: result.data.corpId, // 必填，企业微信的corpID
                            ...configDic
                        })
                    }
                    // wx.config成功回调
                    wx.ready(function(){
                        that.MorAgentConfig(result.data.corpId,result.data.agentId,configDic,morFlagAuthor,morFlagUrl,marignUrl,callback);
                    })
                    if (!/MicroMessenger/i.test(navigator.userAgent)) {
                        debugger
                        that.MorAgentConfig(result.data.corpId,result.data.agentId,configDic,morFlagAuthor,morFlagUrl,marignUrl,callback);
                    }
                } else {
                    that.Msg(res.message);
                    callback(false)
                }
            })
        } else {
            callback(true)
        }
    },
    MorAgentConfig(corpId,agentId,configDic,morFlagAuthor,morFlagUrl,marignUrl,callback){
        wx.agentConfig({
            corpid: corpId, // 必填，企业微信的corpid，必须与当前登录的企业一致
            agentid: parseInt(agentId), // 必填，企业微信的应用id （e.g. 1000247）
            ...configDic,
            success: function (res) {
                // 回调
                console.log(res)
                let num = 2 //失效时间是2小时
                let mortime = new Date(new Date().getTime() + num * 60 * 60 * 1000);
                jsCookie.set(morFlagAuthor, morFlagAuthor, { expires: mortime, path: '/' });
                jsCookie.set(morFlagUrl, marignUrl, { expires: mortime, path: '/' });
                callback(true)
            },
            fail: function (res) {
                // if(res.errMsg.indexOf('function not exist') > -1){
                //     alert('版本过低请升级')
                // }
                console.log(res)
                callback(false)
            }
        });
    },
    // 判断是不是企业微信用户人员名称和部门是否需要转译
    FindIsRetranslationInfo(_this, callback) {
        if (common.GetSystem().sys != common.GetSystem().doc.yi_hr && common.GetSystem().sys != common.GetSystem().doc.yi_notice && common.GetSystem().sys != common.GetSystem().doc.yi_emp) {

            (callback && typeof (callback) === "function") && callback(false);
            return;
        }
        if (location.href.search("/personal/") >= 0) {

            (callback && typeof (callback) === "function") && callback(false);
            return;
        }
        let that = this;
        let whetherToEscape = _this.$store.state.whetherToEscape;

        if (whetherToEscape === undefined) {
            that.Submit(API.main.findEscapeState,
                JSON.stringify({}),
                function (res) {
                    if (res.errorCode == 0) {
                        _this.$store.dispatch("TriggerGetParams", {
                            paramsName: 'whetherToEscape',
                            paramsV: res.result.isOpen
                        })
                        whetherToEscape = res.result.isOpen;
                    } else
                        that.Msg(res.msg);
                });
        }

        (callback && typeof (callback) === "function") && callback(whetherToEscape);
    },


    IsQYWXTranslationList(that, colsList, callback) {
        let Cols = [];
        common.FindIsRetranslationInfo(that, res => {
            if (res) {
                colsList.forEach((e) => {
                    if (e.name && e.type) {
                        Cols.push({
                            field: e.name,
                            templet: function (data) {
                                return '<ww-open-data type="' + e.type + '" openid="' + data[e.name] + '"></ww-open-data>'
                            }
                        })
                    } else {
                        Cols.push({
                            field: e.name,
                            title: ''
                        })
                    }
                });
            }
        });
        (callback && typeof (callback) === "function") && callback(Cols);
    },

    //列表名称穿透（名称展开其他功能入口）  type区分展开哪种
    //类型，贴近的dom对象，行数据，列名
    NameHrefTo: function (type, dom, data, field) {
        type = type * 1;
        let params = `dataid=${data.empId}&xiugai=3&flag=zaizhi&chakan=1&supp=`;
        switch (type) {
            case 1:
                //alert(1);
                // var str = "<div  class='namehref_box'>" + data[field] + "</div>";
                // layui.layer.tips(str, dom, {
                //     
                // });
                var sb = "<div class=\"namehref_box\">";
                sb = sb + "";
                sb = sb + "";
                sb = sb + "            <div class=\"namehref_top\">";
                sb = sb + "";
                sb = sb + "                <div class=\"namehref_head\">";
                sb = sb + "                    <img src=\"/static/img/icon/float_head.png\" />";
                sb = sb + "                </div>";
                sb = sb + "";
                sb = sb + "                <div class=\"namehref_top_text\">";
                sb = sb + "                    <div class=\"namehref_name\">" + data[field] + "</div>";
                // sb = sb + "                    <div class=\"namehref_dept\">";
                // sb = sb + "                        <div>试用 <i></i></div>";
                // sb = sb + "                        <div>测试部<i></i></div>";
                // sb = sb + "                        <div>主管<i></i></div>";
                // sb = sb + "                    </div>";
                // sb = sb + "                    <div class=\"namehref_mobile\">";
                // sb = sb + "                        18811111111";
                // sb = sb + "                    </div>";
                sb = sb + "";
                sb = sb + "";
                sb = sb + "                </div>";
                sb = sb + "";
                sb = sb + "";
                sb = sb + "            </div>";
                sb = sb + "";
                sb = sb + "            <div class=\"namehref_foot\">";
                sb = sb + "";
                sb = sb + "                <div class=\"namehref_msg_title\">";
                sb = sb + "                    <i></i> 员工信息";
                sb = sb + "                </div>";
                sb = sb + "";
                sb = sb + "                <div class=\"namehref_msg_item\">";
                sb = sb + "                    <div><a href=\"/#/company/baseinfo?" + params + "&topstr=empmanage&leftstr=onjob\">个人信息</a><i></i></div>";
                sb = sb + "                    <div>";
                sb = sb + "                        <a href=\"/#/company/postinfo?" + params + "&topstr=empmanage&leftstr=onjob\">岗位信息</a><i></i></div>";
                sb = sb + "                    <div>";
                sb = sb + "                        <a href=\"/#/company/salaryinfo?" + params + "&topstr=empmanage&leftstr=onjob\">薪酬信息</a><i></i></div>";
                sb = sb + "                    <div>";
                sb = sb + "                        <a href=\"/#/company/contractinfo?" + params + "&topstr=empmanage&leftstr=onjob\">合同信息 </a><i></i></div>";
                sb = sb + "                    <div>";
                sb = sb + "                        <a href=\"/#/company/dangandetail?" + params + "&topstr=empmanage&leftstr=onjob\">档案信息</a><i></i></div>";
                sb = sb + "                    <div>";
                sb = sb + "                        <a href=\"/#/company/growlog?" + params + "&topstr=empmanage&leftstr=onjob\">成长记录</a><i></i></div>";
                sb = sb + "";
                sb = sb + "";
                sb = sb + "                </div>";
                sb = sb + "";
                sb = sb + "";
                sb = sb + "                <div class=\"clear\"></div>";
                sb = sb + "";
                // sb = sb + "                <div class=\"namehref_act_title\">";
                // sb = sb + "                    <i></i> 操作";
                // sb = sb + "                </div>";
                // sb = sb + "";
                // sb = sb + "                <div class=\"namehref_act_item\">";
                // sb = sb + "                    <div>转正 <i></i></div>";
                // sb = sb + "                    <div>调岗<i></i></div>";
                // sb = sb + "                    <div>离职<i></i></div>";
                // sb = sb + "                    <div>个人信息 <i></i></div>";
                // sb = sb + "";
                // sb = sb + "";
                // sb = sb + "                </div>";
                sb = sb + "                <div class=\"clear\"></div>";
                sb = sb + "            </div>";
                sb = sb + "";
                sb = sb + "";
                sb = sb + "";
                sb = sb + "";
                sb = sb + "";
                sb = sb + "";
                sb = sb + "";
                sb = sb + "        </div>";


                $(".namehref_box").hide();
                $(dom).css("position", "relative");
                if ($(dom).find(".namehref_box").length == 0) {
                    $(dom).append(sb);
                } else {
                    $($(dom).find(".namehref_box")[0]).show()
                }
                let left = $(dom).offset().left + $(dom).width();
                let top = $(dom).offset().top - 130;
                $(dom).find(".namehref_box").css("top", top).css("left", left);

                $(".main_right").scroll(function () {
                    let top2 = $(dom).offset().top - 130;
                    $(dom).find(".namehref_box").css("top", top2);
                });


                break;

            default:
                break;
        }
    },
    //防抖
    //函数    时间(毫秒)   是否立即生效boolean
    Debounce(func, wait, immediate) {
        var timeout;
        return function () {
            var context = this,
                args = arguments;
            var later = function () {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            if (!timeout) {
                clearTimeout(timeout);
                timeout = setTimeout(later, wait);
            }
            if (callNow) func.apply(context, args);
        };
    },

    //获取系统时间
    WhetherCanReapply: function (applyId, empId, examSource) {
        let isWhether = false;

        let params = {
            applyId,
            empId,
            examSource
        }

        this.Submit(API.EmpInfoApi.checkStartFlow, JSON.stringify(params), function (res) {
            if (res.errorCode == 0) {
                isWhether = true;
            } else {
                common.Msg(res.msg);
            }
        });
        return isWhether;
    },

    GoToIntelligentCompensation(to) {
        if (to === '/webapps/payroll/#/payroll/set/archives?top=1001&left=1004') {
            // 判断是不是有智能薪酬
            let menus = common.Data.Storage("sys_menus")
            let is = false
            menus.forEach(e => {
                if (e.id == '1001')
                    is = true
            })

            if (!is)
                to = to.replace(/top=1001&left=1004/, 'top=18042846892032&left=23199705604096')
        }


        var cs = layui.data("ehr_pcStorage");
        let thisPort = top.location.port;
        let payPort = cs.payport;


        var host = top.location.host; //获取当前窗口的主机名;   结果：localhost:61768

        var payHost = host.replace(":" + thisPort, ":" + payPort);

        location.href = "//" + payHost + to;
    },
    //获取屏幕缩放比例
    GetRatio() {
        var ratio = 0;
        var screen = window.screen;
        var ua = navigator.userAgent.toLowerCase();
        if (window.devicePixelRatio !== undefined) {
            ratio = window.devicePixelRatio;
        }
        else if (~ua.indexOf('msie')) {
            if (screen.deviceXDPI && screen.logicalXDPI) {
                ratio = screen.deviceXDPI / screen.logicalXDPI;
            }
        }
        else if (window.outerWidth !== undefined && window.innerWidth !== undefined) {
            ratio = window.outerWidth / window.innerWidth;
        }
        if (ratio) {
            ratio = Math.round(ratio * 100);
        }
        return ratio;
    },
    // 判断返回错误信息是否包含 "400201", "400202", "400203", "400207"
    isHave12300(JsonObj, url) {
        if (common.isSalarySys(url)) {
            if (JsonObj.code != undefined) {
                if (["400201", "400202", "400203", "400207"].indexOf(JsonObj.code) >= 0) {
                    return true;
                }
            }
        } else {
            if (JsonObj.errorCode != undefined) {
                if (["400201", "400202", "400203", "400207"].indexOf(JsonObj.errorCode) >= 0) {
                    return true;
                }
            }
        }
        return false;
    },
    // 判断返回错误信息是否包含 "400206", "403"
    isHave400(JsonObj, url) {
        if (common.isSalarySys(url)) {
            if (JsonObj.code != undefined) {
                if (["400206", "403"].indexOf(JsonObj.code) >= 0) {
                    return true;
                }
            }
        } else {
            if (JsonObj.errorCode != undefined) {
                if (["400206", "403"].indexOf(JsonObj.errorCode) >= 0) {
                    return true;
                }
            }
        }
        return false;
    },
    // 判断是否是智能薪酬微服务的接口
    isSalarySys(url) {
        let marignurl = url;
        if (url.indexOf('/') != 0) {
            marignurl = '/' + url
        }
        if (marignurl.indexOf('/payrollbase/') == 0 || marignurl.indexOf('/excel/') == 0 || marignurl.indexOf('/payslip/') == 0 || marignurl.indexOf('/auth/') == 0 || marignurl.indexOf('/message/') == 0 || marignurl.indexOf('/global/') == 0 || marignurl.indexOf('/tools/') == 0 || marignurl.indexOf('/organize/') == 0 || marignurl.indexOf('/personnel/') == 0 || marignurl.indexOf('/soin/') == 0 || marignurl.indexOf('/saastosimple/') == 0|| marignurl.indexOf('/statistics/') == 0) {
            return true;
        }
        return false;
    },
    // 如果是智能薪酬微服务不用拼接ehr_saas
    backBaseApi(url) {
        if (common.isSalarySys(url)) {
            return API.apiBase.substring(0, API.apiBase.length - 9)
        }
        return API.apiBase
    },
    Http: HTTP
}
export default common;